import { useLazyMeQuery } from 'api/auth';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFormClean } from 'store/reducers/formslice';
import { clearToken } from 'store/slice/auth-slice';
import { resetUploadState } from 'store/slice/design/uploadSlice';
import { clearInitiator, isInitiator } from 'utils/authUtils';
declare var window: any;

const useAuthSync = () => {
  const dispatch = useDispatch();
  const [fetchMe] = useLazyMeQuery();

  const handleAuthChange = async (type: 'logout' | 'refresh' | 'login' | any) => {
    if (!isInitiator()) {
      if (['refresh', 'login'].includes(type)) {
        await fetchMe();
      } else if (type === 'logout') {
        dispatch(setFormClean()); // To disable page blocker while session is expired
        dispatch(clearToken());
        dispatch(resetUploadState());
      }
    }
  };

  useEffect(() => {
    const processEvent = (type: any) => {
      if (!document.hidden) {
        // Only process when active
        handleAuthChange(type);
        sessionStorage.removeItem('auth-pending'); // Clear onceprocessed
      } else {
        sessionStorage.setItem('auth-pending', type); // Store forlater
      }
    };
    if ('BroadcastChannel' in window) {
      const authChannel = new BroadcastChannel('auth');
      authChannel.addEventListener('message', (event) => processEvent(event.data.type));

      clearInitiator();
      return () => {
        authChannel.removeEventListener('message', (event) => processEvent(event.data.type));
        authChannel.close();
      };
    } else {
      const handleStorageChange = (event: any) => {
        if (event.key === 'auth-changed') {
          const data = JSON.parse(event.newValue || '{}');
          processEvent(data.type);
        }
      };

      window.addEventListener('storage', handleStorageChange);
      clearInitiator();
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        const pendingType = sessionStorage.getItem('auth-pending');
        if (pendingType) {
          handleAuthChange(pendingType);
          sessionStorage.removeItem('auth-pending');
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
};

export default useAuthSync;
